export const Utils = {
	mounted() {
	},
	methods: {
		basename(path) {
			if(path) {
				return path.split(/[\\/]/).pop();
			}
		},
		scrollTo(element) {
			var top = element.offsetTop;

			window.scrollTo(0, top);
		},
		slug(string) {
			if(typeof string == 'string') {
				string = string.replace(/(<([^>]+)>)/ig,"");
				string = string.replace(/#/ig,"-");
				const a = 'àáäâãåèéëêìíïîòóöôùúüûñçßÿœæŕśńṕẃǵǹḿǘẍźḧ·/_,:;'
				const b = 'aaaaaaeeeeiiiioooouuuuncsyoarsnpwgnmuxzh------'
				const p = new RegExp(a.split('').join('|'), 'g')
				return string.toString().toLowerCase()
				.replace(/\s+/g, '-')
				.replace(p, c => b.charAt(a.indexOf(c)))
				.replace(/&/g, '-and-')
				.replace(/[^\w\-]+/g, '')
				.replace(/\-\-+/g, '-')
				.replace(/^-+/, '')
			}
		},			
		resume(text, length=100) {
			let ret = text.substr(0,length);
			if(ret.length < text.length) {
				ret+='...';
			}
			return ret;
		},
		nl2br(str, is_xhtml) {
			if (typeof str === 'undefined' || str === null) {
				return '';
			}
			var breakTag = (is_xhtml || typeof is_xhtml === 'undefined') ? '<br />' : '<br>';
			return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
		},	
	
		hashCode(str) { 
			var hash = 0;
			for (var i = 0; i < str.length; i++) {
				hash = str.charCodeAt(i) + ((hash << 5) - hash);
			}
			return hash;
		} ,
		intToRGB(i){
			var c = (i & 0x00FFFFFF)
			.toString(16)
			.toUpperCase();

			return "00000".substring(0, 6 - c.length) + c;
		}
		
	}
}




// WEBPACK FOOTER //
// ./src/components/mixins/utils.js